import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './../Login/AuthContext';
import './../../styles/navbar.css';

const MegaMenu = ({ label, columns }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <li
      className="nav-item mega-menu-item"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <Link to="#" className="nav-links">
        {label} <span>›</span>
      </Link>
      {isOpen && (
        <div className="mega-menu-content">
          {columns.map((column, index) => (
            <div key={index} className="mega-menu-column">
              <h4>{column.title}</h4>
              <ul>
                {column.items.map((item, i) => (
                  <li key={i}>
                    <Link
                      to={item.to || "#"}
                      className="mega-menu-link"
                      onClick={item.onClick}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </li>
  );
};

const Navbar = () => {
  const { isAuthenticated, logout } = useAuth();

const GestionColumns = [
  {
    title: "Facturation",
    items: [
      { label: "Créer une facture d'achat", to: "/factures/achat/creer" },
      { label: "Liste des factures d'achat", to: "/factures/achat/liste" },
      { label: "Relancer un fournisseur", to: "/factures/achat/relances" },
      { label: "Factures de vente", to: "/factures/vente/liste" },
      { label: "Créer une facture de vente", to: "/factures/vente/creer" },
      { label: "Créer un avoir", to: "/factures/vente/avoirs/creer" },
      { label: "Liste des avoirs", to: "/factures/vente/avoirs/liste" },
      { label: "Devis", to: "/factures/devis/liste" },
      { label: "Créer un devis", to: "/factures/devis/creer" },
      { label: "Suivi des paiements", to: "/factures/suivi-paiements" },
      { label: "Statistiques de facturation", to: "/factures/statistiques" },
    ],
  },
  {
    title: "Trésorerie & Banque",
    items: [
      { label: "Créer un mouvement bancaire", to: "/banque/mouvement/creer" },
      { label: "Liste des mouvements", to: "/banque/mouvement/liste" },
      { label: "Rapprochement bancaire", to: "/banque/rapprochement" },
      { label: "Relevés bancaires", to: "/banque/relevés" },
      { label: "Prévisions de trésorerie", to: "/banque/previsions" },
      { label: "Flux de trésorerie", to: "/banque/flux" },
      { label: "Catégories bancaires", to: "/banque/categories" },
      { label: "Transferts entre comptes", to: "/banque/transferts" },
    ],
  },
  {
    title: "Clients & Fournisseurs",
    items: [
      { label: "Liste des clients", to: "/contacts/clients" },
      { label: "Ajouter un client", to: "/contacts/clients/ajouter" },
      { label: "Liste des fournisseurs", to: "/contacts/fournisseurs" },
      { label: "Ajouter un fournisseur", to: "/contacts/fournisseurs/ajouter" },
      { label: "Contrats clients", to: "/contacts/contrats-clients" },
      { label: "Contrats fournisseurs", to: "/contacts/contrats-fournisseurs" },
      { label: "Historique des transactions", to: "/contacts/historique" },
    ],
  },
  {
    title: "Stocks & Inventaire",
    items: [
      { label: "Liste des produits/services", to: "/stocks/produits" },
      { label: "Ajouter un produit/service", to: "/stocks/produits/ajouter" },
      { label: "Inventaire", to: "/stocks/inventaire" },
      { label: "Alertes de stock", to: "/stocks/alertes" },
      { label: "Valuation des stocks", to: "/stocks/valuation" },
    ],
  },
  {
    title: "Comptabilité",
    items: [
      { label: "Écritures comptables", to: "/comptabilité/ecritures" },
      { label: "Créer une écriture", to: "/comptabilité/ecritures/creer" },
      { label: "Plan comptable", to: "/comptabilité/plan-comptable" },
      { label: "Journal général", to: "/comptabilité/journal" },
      { label: "Balance comptable", to: "/comptabilité/balance" },
      { label: "Grand livre", to: "/comptabilité/grand-livre" },
      { label: "Clôture d'exercice", to: "/comptabilité/cloture" },
    ],
  },
  {
    title: "Projets & Temps",
    items: [
      { label: "Liste des projets", to: "/projets/liste" },
      { label: "Créer un projet", to: "/projets/creer" },
      { label: "Suivi des temps", to: "/projets/temps" },
      { label: "Facturation par projet", to: "/projets/facturation" },
      { label: "Budget par projet", to: "/projets/budget" },
      { label: "Rentabilité des projets", to: "/projets/rentabilite" },
    ],
  },
];


  const reportsColumns = [
    {
      title: "Comptables",
      items: [
        { label: "Bilan Comptable", to: "/reports/comptables/bilan" },
        { label: "Compte de Résultat", to: "/reports/comptables/compte-resultat" },
        { label: "Grand Livre", to: "/reports/comptables/grand-livre" },
        { label: "Balance Comptable", to: "/reports/comptables/balance" },
      ],
    },
    {
      title: "Fiscaux",
      items: [
        { label: "Déclaration de TVA", to: "/reports/fiscaux/declaration-tva" },
        { label: "Liasse Fiscale", to: "/reports/fiscaux/liasse-fiscale" },
        { label: "Impôt sur les Sociétés", to: "/reports/fiscaux/impot-societes" },
        { label: "CFE/CVAE", to: "/reports/fiscaux/cfecvae" },
      ],
    },
    {
      title: "Sociaux",
      items: [
        { label: "Déclaration Sociale (DSN)", to: "/reports/sociaux/declaration-sociale" },
        { label: "Masse Salariale", to: "/reports/sociaux/masse-salariale" },
        { label: "Récapitulatif des Cotisations", to: "/reports/sociaux/cotisations" },
        { label: "Bulletin de Salaire", to: "/bulletin-de-salaire" },
        { label: "Ajouter un employé", to: "/ajouter-employe" },
      ],
    },
    {
      title: "Analytiques",
      items: [
        { label: "Tableau de Trésorerie", to: "/reports/analytiques/trésorerie" },
        { label: "Ratios Financiers", to: "/reports/analytiques/ratios" },
      ],
    },
  ];

  const financeColumns = [
    {
      title: "Trésorerie",
      items: [
        { label: "Consulter mon solde", to: "/solde_bancaire" },
        { label: "Relevés bancaires", to: "/finance/relevés-bancaires" },
        { label: "Prévisions de trésorerie", to: "/finance/previsions-tresorerie" },
        { label: "Flux de trésorerie", to: "/finance/flux-tresorerie" },
      ],
    },
    {
      title: "Dépenses",
      items: [
        { label: "Liste des dépenses", to: "/finance/liste-depenses" },
        { label: "Ajouter une dépense", to: "/finance/ajouter-depense" },
        { label: "Catégories de dépenses", to: "/finance/categories-depenses" },
        { label: "Rapprochement bancaire", to: "/finance/rapprochement" },
      ],
    },
    {
      title: "Investissements",
      items: [
        { label: "Suivi des investissements", to: "/finance/suivi-investissements" },
        { label: "Amortissements", to: "/finance/amortissements" },
        { label: "Plan d’investissement", to: "/finance/plan-investissement" },
      ],
    },
    {
      title: "Financement",
      items: [
        { label: "Prêts et crédits", to: "/finance/prets-credits" },
        { label: "Tableau d’emprunts", to: "/finance/tableau-emprunts" },
        { label: "Leasing (LLD/LOA)", to: "/finance/leasing" },
      ],
    },
    {
      title: "Analyse financière",
      items: [
        { label: "Ratios clés", to: "/finance/ratios-cles" },
        { label: "Seuil de rentabilité", to: "/finance/seuil-rentabilite" },
        { label: "Benchmark sectoriel", to: "/finance/benchmark" },
      ],
    },
    {
      title: "Budget",
      items: [
        { label: "Créer un budget", to: "/finance/creer-budget" },
        { label: "Suivi budgétaire", to: "/finance/suivi-budget" },
        { label: "Écarts budgétaires", to: "/finance/ecarts-budget" },
      ],
    },
  ];

const accountColumns = [
  {
    title: "Mon Compte",
    items: [
      { label: "Profil", to: "/profile" },
      { label: "Paramètres généraux", to: "/settings" },
      { label: "Préférences d’affichage", to: "/settings/affichage" },
      { label: "Langue et région", to: "/settings/langue" },
      { label: "Déconnexion", to: "#", onClick: logout },
    ],
  },
  {
    title: "Abonnement",
    items: [
      { label: "Mon abonnement actuel", to: "/abonnement" },
      { label: "Changer de formule", to: "/abonnement/changer" },
      { label: "Historique des paiements", to: "/abonnement/historique" },
      { label: "Factures d’abonnement", to: "/abonnement/factures" },
      { label: "Modes de paiement", to: "/abonnement/modes-paiement" },
    ],
  },
  {
    title: "Sécurité",
    items: [
      { label: "Changer le mot de passe", to: "/securite/mot-de-passe" },
      { label: "Authentification à deux facteurs", to: "/securite/2fa" },
      { label: "Appareils connectés", to: "/securite/appareils" },
      { label: "Journal des activités", to: "/securite/journal" },
    ],
  },
  {
    title: "Notifications",
    items: [
      { label: "Préférences de notification", to: "/notifications/preferences" },
      { label: "Historique des notifications", to: "/notifications/historique" },
    ],
  },
  {
    title: "Support",
    items: [
      { label: "Centre d’aide", to: "/support/centre-aide" },
      { label: "Nous contacter", to: "/support/contact" },
    ],
  },
  {
    title: "Intégrations",
    items: [
      { label: "Applications connectées", to: "/integrations/applications" },
      { label: "API et développeurs", to: "/integrations/api" },
      { label: "Webhooks", to: "/integrations/webhooks" },
    ],
  },
];


  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/accueil" className="navbar-logo">
          ComptaApp
        </Link>
        <ul className="nav-menu">
          <MegaMenu label="Gestion" columns={GestionColumns} />
          <MegaMenu label="Reports" columns={reportsColumns} />
          <MegaMenu label="Finances" columns={financeColumns} />
          {isAuthenticated ? (
            <MegaMenu label="Gestion du compte" columns={accountColumns} />
          ) : (
            <>
              <li className="nav-item">
                <Link to="/login" className="nav-links">
                  Se connecter
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/register" className="nav-links">
                  Créer un compte
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
